import { pageStatus } from '@/utils/pageInfo';
export default {
  data () {
    return {
      originData: {
        status: '',
        id: ''
      }
    }
  },
  methods: {
    checkQueryParams (vm) {
      // 从其他页面进入
      const queryParams = vm.$route.query;
      if (!queryParams.reload && queryParams.status === this.originData.status && queryParams.id === this.originData.id) {
        return;
      } else {
        this.originData.status = queryParams.status;
        this.originData.id = queryParams.id;
      }
      if (queryParams.status) {
        vm.resetForm();
        const { name, status, disabled } = pageStatus.find(
          item => item.status === queryParams.status,
        );
        vm.status = status;
        vm.statusName = name;
        vm.formDisabled = disabled;
      }
      // 获取数据
      if (queryParams.id && queryParams.status !== 'add') {
        const { name, status, disabled } = pageStatus.find(
          item => item.status === queryParams.status,
        );
        vm.status = status;
        vm.statusName = name;
        vm.row.id = queryParams.id;
        vm.id = queryParams.productId;
        vm.formDisabled = disabled;
        vm.$nextTick(() => {
          vm.getDetail();
        });
      }
      if (queryParams.scroll) {
        this.pageScroll(queryParams.scroll)
      }
    },
    // 去除末尾小数点
    deleteLastDot(params, arr) {
      arr.map(el => {
        const lastCode = params[el] && params[el].substr(params[el].length-1, 1);
        params[el] = lastCode === '.' ? params[el].slice(0, params[el].length-1) : params[el];
      });
    },
    // 滚动到指定dom
    pageScrollToTop(id='cml-divider') {
      this.pageScroll(id);
    },
    pageScroll (id) {
      setTimeout(() => {
        document.querySelector(`#${id}`).scrollIntoView();
      }, 300)
    },
    // to样品列表页
    toSamplePage (
      status,
      paramName = 'sample-manage/sample-list',
      name = '样品列表',
    ) {
      this.dialogVisible = false;
      this.$store.dispatch('tagsView/jumpAndClosePage', {
        close: {
          name: this.$route.meta.title,
          href: this.$route.path,
        },
        open: {
          name: name,
          href: `/${paramName}`,
        },
      });
      this.$router.push({
        name: paramName,
        params: {
          status,
          row: this.row,
        },
      });
    },
    // 取消
    createAgain () {
      this.dialogVisible = false;
      this.resetForm();
      this.pageScroll('cml-divider');
      this.$nextTick(() => {
        const name = this.$route.meta.title;
        const paramName = this.$route.name;
        this.$store.dispatch('tagsView/jumpAndClosePage', {
          open: {
            name: name,
            href: `/${paramName}?status=add`,
          },
        });
        this.$router.push({
          name: paramName,
          params: {
            status: 'add'
          },
        });
      })
    },
    // 提交
    submitBtn () {
      this.$refs.formData.validate(valid => {
        if(valid) {
          this.saveBtn('submit');
        } else {
          this.$message.error('必填项不能为空，请认真检查哦！');
          this.pageScrollToTop();
          return false;
        }
      });
    },
    // 审核
    verifyBtn () {
      this.$refs.verifyComponent.$refs.verifyFormData.validate(valid => {
        valid && this.saveBtn();
      });
    },
  }
}